import React from 'react';
import { Descriptions, Result } from 'antd';
import { IResultStepProps } from './i-import-wizard';
import { MUTED_TEXT } from './import-tags';
import ProblemTable from './problem-table';

const TITLES: Record<string, string> = {
  done: 'Imported',
  cancelled: 'Import cancelled',
  failed: 'Import stopped',
};

const ResultStep = (props: IResultStepProps): JSX.Element => {
  const {
    job, problems, problemPage, problemsLoading, downloading, onProblemPage, onDownloadProblems,
  } = props;

  const state = job?.state ?? 'done';
  const failed = job?.failed ?? 0;
  const created = job?.created ?? 0;
  const partial = state === 'cancelled' || state === 'failed';

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <Result
        status={partial || failed > 0 ? 'warning' : 'success'}
        title={TITLES[state] ?? 'Imported'}
        subTitle={job?.message ?? undefined}
        style={{ padding: '24px 0 8px' }}
      />

      <Descriptions column={1} size="small" bordered>
        <Descriptions.Item label="Created">{created.toLocaleString()}</Descriptions.Item>
        {(job?.updated ?? 0) > 0 ? (
          <Descriptions.Item label="Updated">{job?.updated.toLocaleString()}</Descriptions.Item>
        ) : null}
        <Descriptions.Item label="Skipped as duplicates">
          {(job?.skipped ?? 0).toLocaleString()}
        </Descriptions.Item>
        {failed > 0 ? (
          <Descriptions.Item label="Failed">{failed.toLocaleString()}</Descriptions.Item>
        ) : null}
        <Descriptions.Item label="Rows in the file">
          {(job?.total ?? 0).toLocaleString()}
        </Descriptions.Item>
      </Descriptions>

      {partial ? (
        <div style={{ fontSize: 13 }}>
          {`${created.toLocaleString()} asset types were created before the import stopped. `}
          They are kept. Running the same file again is safe — anything already there is skipped.
        </div>
      ) : null}

      <div style={MUTED_TEXT}>
        {/* the list reads a Mongo projection fed one message at a time; at
            200k rows it is minutes behind, not the couple of seconds the old
            copy promised */}
        The asset types exist now. The list page may take several minutes to catch up.
      </div>

      {(job?.errorCount ?? 0) > 0 ? (
        <ProblemTable
          rows={problems}
          total={job?.errorCount ?? 0}
          truncated={job?.errorTruncated ?? false}
          page={problemPage}
          loading={problemsLoading}
          downloading={downloading}
          onPageChange={onProblemPage}
          onDownload={onDownloadProblems}
        />
      ) : null}
    </div>
  );
};

ResultStep.displayName = 'ResultStep';

export default ResultStep;
